import { render, staticRenderFns } from "./ProviderCard.vue?vue&type=template&id=7149c32c&scoped=true"
import script from "./ProviderCard.vue?vue&type=script&lang=js"
export * from "./ProviderCard.vue?vue&type=script&lang=js"
import style0 from "./ProviderCard.vue?vue&type=style&index=0&id=7149c32c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7149c32c",
  null
  
)

export default component.exports